module.exports = __webpack_public_path__ + "static/media/add-group-white.7bc95bfa.svg";